// src/utils/deviceId.ts

import { getCookie, setCookie } from 'cookies-next';

// Lightweight UUID v4 generator for browser
export function getOrCreateDeviceId(): string {
  const key = 'deviceId';
  let deviceId = getCookie(key);

  if (!deviceId) {
    deviceId = generateUUID();
    setCookie('deviceId', deviceId, {
      secure: true,
      sameSite: 'strict',
      maxAge: 60 * 60 * 24 * 400, // 400 วัน (สูงสุดที่ Chrome รองรับ)
    });
  }

  return deviceId.toString();
}

function generateUUID(): string {
  // RFC4122 version 4 compliant UUID
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    const r = (Math.random() * 16) | 0,
      v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}
